import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  HeaderGlobalAction,
  HeaderGlobalBar,
  HeaderPanel
} from 'carbon-components-react/lib/components/UIShell';
import { UserProfile } from 'modules';
import { NotificationOptionsModal } from 'components';
import { setHeaderPanelExpand } from 'redux/app/actions';
import { selectHeaderPanelExpand } from 'redux/app/selectors';
import { UserAvatar16, Close16, Help16 } from '@carbon/icons-react';
import NotificationPanel from '../HeaderPanel/Notification';
import UserPanel from '../HeaderPanel/User';
import HelpPanel from '../HeaderPanel/Help';
import { Tabs } from '../../Tabs';
import { DBYD_1100_URL } from 'types';

// Typings
type ActionType = {
  type: 'help' | 'notification' | 'appSwitcher' | 'account';
};

const AuthGlobalToolBar: React.FC<any> = () => {
  const dispatch = useDispatch();
  const headerPanelExpand: any = useSelector(selectHeaderPanelExpand);

  const [isNotificationPanel, setIsNotificationPanel] = useState<Boolean>(
    false
  );
  const [isAccountPanel, setIsAccountPanel] = useState<Boolean>(false);
  const [isHelpPanel, setIsHelpPanel] = useState<Boolean>(false);

  const resetIconStateHandler = () => {
    setIsAccountPanel(false);
    setIsHelpPanel(false);
    setIsNotificationPanel(false);
    dispatch(setHeaderPanelExpand({ isOpen: true }));
  };

  const toggleRightPanel = (panel?: string) => {
    resetIconStateHandler();
    dispatch(
      setHeaderPanelExpand({ panel, isOpen: !headerPanelExpand.isOpen })
    );
  };

  const clickHandler = (action: ActionType) => {
    //resetIconStateHandler();
    switch (action.type) {
      case 'help':
        isHelpPanel
          ? toggleRightPanel(action.type)
          : dispatch(setHeaderPanelExpand({ panel: 'help', isOpen: true }));
        break;
      case 'notification':
        isNotificationPanel
          ? toggleRightPanel(action.type)
          : dispatch(
              setHeaderPanelExpand({ panel: 'notification', isOpen: true })
            );
        break;
      case 'account':
        isAccountPanel
          ? toggleRightPanel(action.type)
          : dispatch(setHeaderPanelExpand({ panel: 'account', isOpen: true }));
        break;
      default:
        toggleRightPanel(undefined);
        break;
    }
  };

  useEffect(() => {
    if (headerPanelExpand) {
      const { isOpen, panel } = headerPanelExpand;
      setIsHelpPanel(isOpen && panel === 'help');
      setIsNotificationPanel(isOpen && panel === 'notification');
      setIsAccountPanel(isOpen && panel === 'account');
      if (headerPanelExpand.isOpen) {
        document
          .querySelector('.main-content--wrapper')
          ?.addEventListener('click', () => {
            dispatch(setHeaderPanelExpand({ isOpen: false }));
          });

        document
          .querySelector('.leftHandSideNav')
          ?.addEventListener('click', () => {
            dispatch(setHeaderPanelExpand({ isOpen: false }));
          });
      }
    }
  }, [dispatch, headerPanelExpand]);

  return (
    <HeaderGlobalBar>
      <Tabs>
        <Tabs.Tab label="help">
          <HeaderGlobalAction
            aria-label="Help"
            onClick={() => {
              window.open(DBYD_1100_URL.HELP, '_blank');
            }}
          >
            <Help16 />
          </HeaderGlobalAction>
        </Tabs.Tab>
        <Tabs.Tab label="account">
          <HeaderGlobalAction
            aria-label="account"
            onClick={() => {
              clickHandler({ type: 'account' });
            }}
          >
            {isAccountPanel ? <Close16 /> : <UserAvatar16 />}
          </HeaderGlobalAction>
        </Tabs.Tab>
        <HeaderPanel
          id="header-panel"
          aria-label="Header Panel"
          expanded={headerPanelExpand?.isOpen === true}
        >
          {isHelpPanel && <HelpPanel />}
          {isNotificationPanel && <NotificationPanel />}
          {isAccountPanel && <UserPanel />}
        </HeaderPanel>
      </Tabs>
      <UserProfile />
      <NotificationOptionsModal />
    </HeaderGlobalBar>
  );
};

export default React.memo(AuthGlobalToolBar);
